import type { Helix2000Character } from '../../../../shared/CharacterTypes';
import { abilityBaseDamage } from '../../../../shared/logic/abilityBaseDamage';

export type BasicAttackId = 'warrior_auto' | 'mage_auto' | 'ranger_auto' | 'assassin_auto'
  | 'paladin_auto' | 'priest_auto' | 'shaman_auto' | 'warlock_auto' | 'druid_auto';

/** Client-side base only: the authoritative hit still applies target matchup,
 * crit, variance and defense. Never infer scaling from school or local buffs. */
export function basicAttackDamage(
  abilityId: BasicAttackId,
  player: Pick<Helix2000Character, 'class' | 'level' | 'stats' | 'magicAttack'>,
): number {
  return abilityBaseDamage({
    heroClass: player.class,
    level: player.level,
    attack: player.stats?.attack ?? 0,
    magicAttack: player.stats?.magicAttack ?? player.magicAttack ?? 0,
  }, abilityId);
}
